export default (({response}) => {
  if (response.data.hasOwnProperty('errors')) {
    const h = window.app.$createElement;
    let errors = response.data.errors;

    const content =
      h('ul',
        {},
        Object.keys(errors).map(key => h('li', {}, errors[key][0]))
        );

    window.app.$bvToast.toast([content], {
      title: 'Er is iets fout gegaan...',
      variant: 'danger',
      solid: true,
      toaster: 'b-toaster-top-center',
    });
  }
});
